var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pb-16"},[_c('account-settings'),_c('v-btn',{staticClass:"mb-6 mt-2 button-md",attrs:{"color":"danger500","depressed":"","dark":"","block":""},on:{"click":_vm.handleLogout}},[_vm._v("Logout")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }